module.exports = __webpack_public_path__ + "img/shezhi.8637bc3d.png";